import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { CreatePlanBillingOptionRequest } from "@shopexperts/legacy-api";
import { extractBillingApiMessage } from "./billingOptionForm";

export function useCreateBillingOption() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, error } = useMutation({
    mutationKey: ["admin", "expert-plans", "billing-options", "create"],
    mutationFn: ({ planId, data }: { planId: number; data: CreatePlanBillingOptionRequest }) => {
      return api.admin.expertBilling.createBillingOption({ params: { plan: planId }, body: data });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-plans"] });
      toaster.create({
        title: "Billing option created",
        description: "Created as not sellable. Turn it on when ready; Stripe syncs automatically.",
        type: "success",
      });
    },
    onError: (err: Error) => {
      toaster.create({
        title: "Failed to create billing option",
        description: extractBillingApiMessage(err) ?? "An unexpected error occurred",
        type: "error",
      });
      console.error("[useCreateBillingOption] Error:", err);
    },
  });

  return { mutate, mutateAsync, isPending, error };
}

export default useCreateBillingOption;
